<template>
    <div class="menu-parent">
        <ul class="side-menu pl-0" role="menu">
            <li
                class="menu-item pt-3 pb-2 px-3 text-dark cursor-pointer"
                :class="
                    (m.hasOwnProperty('items') && m.items.length) || !m.title ? '' : 'border-bottom'
                "
                v-for="m in sideMenuItems"
                :key="m.name"
            >
                <h6 class="m-0">
                    <a
                        class="menu-title"
                        :class="[
                            m.class,
                            {
                                'font-weight-bold text-black': isCurrentComponent(m),
                                'text-dark': !isCurrentComponent(m),
                            },
                        ]"
                        :href="'#' || `/help/category/${m.id}`"
                        role="button"
                        aria-expanded="false"
                        >{{ m.name }}</a
                    >
                </h6>
                <div v-if="m.help_article" class="cursor-pointer" :id="`${m.name}`">
                    <div
                        v-for="it in m.help_article"
                        class="py-2 pl-3 mb-0 menu-title border-bottom"
                    >
                        <a
                            @click="hash = `#${it.id}`"
                            :class="[
                                it.class,
                                {
                                    'font-weight-bold text-black': isCurrentComponent(it),
                                    'text-dark': !isCurrentComponent(it),
                                },
                            ]"
                            :href="`#${it.id}`"
                            :key="it.title"
                            >{{ it.title }}</a
                        >
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "HelpCenterSideMenu",
    props: ["sideMenuItems", "header", "topLevelProperty", "parentComponent", "currentComponent"],
    data() {
        return {
            hash: window ? window.location.hash : "",
        };
    },
    created() {},
    mounted() {},
    methods: {
        funcRef() {},
        isCurrentComponent(m) {
            //Category
            if (
                window &&
                window.location.href.includes("category") &&
                parseInt(window.location.href.split("/").pop()) === m.id &&
                m.hasOwnProperty("name")
            ) {
                return true;
            }
            //Hash
            if (window && this.hash === `#${m.id}` && m.hasOwnProperty("title")) {
                return true;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.side-menu {
    transition: all 0.6s;
    list-style-type: none;

    > .menu-item > h6 > a:hover {
        text-decoration: none;
    }
    > .menu-item {
        font-weight: 500;
    }
}

.menu-title {
    font-size: 90%;
}
</style>
